import { Injectable } from '@angular/core';
import { locationData } from './location.data';

@Injectable({
  providedIn: 'root'
})
export class LocationService {


  // TODO : Move to Function service
  getCounties(): Promise<County[]> {
    //  var counties : County[] = locationData;
    var counties = locationData.counties;
    counties.sort(compare);
    counties.forEach(p=>{
      p.locations.sort(compare);
    })
    return Promise.resolve(locationData.counties);
  }

  constructor() { }
}


export class County {
  name: string
  locations: Location[]
}

export class Location {
  name: string
}


function compare(a,b) {
  if (a.name < b.name)
    return -1;
  if (a.name > b.name)
    return 1;
  return 0;
}

